'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactUtils = require('react-utils');

var _FormActions = require('MeetingsLib/redux/actions/FormActions');

var FormActions = _interopRequireWildcard(_FormActions);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UIBox = require('UIComponents/layout/UIBox');

var _UIBox2 = _interopRequireDefault(_UIBox);

var _UICard = require('UIComponents/card/UICard');

var _UICard2 = _interopRequireDefault(_UICard);

var _EmailForm = require('MeetingsLib/components/sections/EmailForm');

var _EmailForm2 = _interopRequireDefault(_EmailForm);

var _DatePickerSection = require('MeetingsLib/components/sections/DatePickerSection');

var _DatePickerSection2 = _interopRequireDefault(_DatePickerSection);

var _TimeOptionsSection = require('MeetingsLib/components/sections/TimeOptionsSection');

var _TimeOptionsSection2 = _interopRequireDefault(_TimeOptionsSection);

var _PropertyForm = require('MeetingsLib/components/sections/PropertyForm');

var _PropertyForm2 = _interopRequireDefault(_PropertyForm);

var _LegalConsentForm = require('MeetingsLib/components/sections/LegalConsentForm');

var _LegalConsentForm2 = _interopRequireDefault(_LegalConsentForm);

var _UserProfile = require('MeetingsBase/models/UserProfile');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _BookingLifecycle = require('MeetingsLib/models/BookingLifecycle');

var _BookingLifecycle2 = _interopRequireDefault(_BookingLifecycle);

var _FormState = require('MeetingsLib/models/FormState');

var _FormState2 = _interopRequireDefault(_FormState);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullSizeBookingPage = _react2.default.createClass({
  displayName: 'FullSizeBookingPage',

  propTypes: {
    avatar: _react.PropTypes.string,
    branding: _react.PropTypes.instanceOf(_Branding2.default).isRequired,
    canAutoSubmitPropertyForm: _react.PropTypes.bool,
    autoSubmitPropertyFormInvalid: _react.PropTypes.bool,
    canTroubleshoot: _react.PropTypes.bool,
    embedded: _react.PropTypes.bool.isRequired,
    headline: _react.PropTypes.string,
    isFetchingPublicAvailability: _react.PropTypes.bool.isRequired,
    isFetchingPublicGlobalBranding: _react.PropTypes.bool.isRequired,
    isSalesStarter: _react.PropTypes.bool,
    markShowedEmailForm: _react.PropTypes.func.isRequired,
    profile: _react.PropTypes.instanceOf(_UserProfile2.default).isRequired,
    shouldShowEmailForm: _react.PropTypes.bool,
    bookingLifecycle: _react.PropTypes.instanceOf(_BookingLifecycle2.default).isRequired,
    formState: _react.PropTypes.instanceOf(_FormState2.default),
    legalConsentEnabled: _react.PropTypes.bool.isRequired,
    legalConsentResponses: _react.PropTypes.instanceOf(_immutable.List),
    resetEventDateTime: _react.PropTypes.func.isRequired,
    resetFormState: _react.PropTypes.func.isRequired,
    submittingMeeting: _react.PropTypes.bool
  },

  getClassNames: function getClassNames() {
    var _props = this.props,
        embedded = _props.embedded,
        isSalesStarter = _props.isSalesStarter,
        canTroubleshoot = _props.canTroubleshoot;

    return (0, _reactUtils.classNames)('fullsize-container m-x-auto', {
      'p-top-4': !embedded,
      'p-top-12': !isSalesStarter && !canTroubleshoot
    });
  },
  getLegalBackFunction: function getLegalBackFunction() {
    var _props2 = this.props,
        canAutoSubmitPropertyForm = _props2.canAutoSubmitPropertyForm,
        resetEventDateTime = _props2.resetEventDateTime,
        resetFormState = _props2.resetFormState;


    return canAutoSubmitPropertyForm ? resetEventDateTime : resetFormState;
  },
  renderEmailForm: function renderEmailForm() {
    var _props3 = this.props,
        branding = _props3.branding,
        markShowedEmailForm = _props3.markShowedEmailForm;

    return _react2.default.createElement(_EmailForm2.default, {
      branding: branding,
      compact: false,
      goToNextStep: function goToNextStep() {},
      markShowedEmailForm: markShowedEmailForm
    });
  },
  renderDateTimeStep: function renderDateTimeStep() {
    var _props4 = this.props,
        avatar = _props4.avatar,
        headline = _props4.headline,
        embedded = _props4.embedded,
        branding = _props4.branding,
        profile = _props4.profile,
        isFetchingPublicAvailability = _props4.isFetchingPublicAvailability,
        isFetchingPublicGlobalBranding = _props4.isFetchingPublicGlobalBranding;


    return _react2.default.createElement(
      _UICard2.default,
      { key: 'full-datetime', className: 'p-all-0 height-100' },
      _react2.default.createElement(
        _UIFlex2.default,
        { className: 'height-100', direction: 'row', align: 'stretch' },
        _react2.default.createElement(
          _UIBox2.default,
          { basis: '50%', className: 'height-100' },
          _react2.default.createElement(_DatePickerSection2.default, {
            compact: false,
            avatar: avatar,
            branding: branding,
            embedded: embedded,
            headline: headline,
            isFetchingPublicGlobalBranding: isFetchingPublicGlobalBranding,
            profile: profile
          })
        ),
        _react2.default.createElement(
          _UIBox2.default,
          { basis: '50%', className: 'height-100' },
          _react2.default.createElement(_TimeOptionsSection2.default, {
            compact: false,
            branding: branding,
            profile: profile,
            isFetchingPublicAvailability: isFetchingPublicAvailability
          })
        )
      )
    );
  },
  renderPropertyForm: function renderPropertyForm() {
    var _props5 = this.props,
        submittingMeeting = _props5.submittingMeeting,
        bookingLifecycle = _props5.bookingLifecycle,
        resetEventDateTime = _props5.resetEventDateTime;


    return _react2.default.createElement(_PropertyForm2.default, {
      key: 'full-property',
      goToPreviousStep: resetEventDateTime,
      dateTime: bookingLifecycle.event.dateTime,
      submittingMeeting: submittingMeeting
    });
  },
  renderLegalConsentFormSection: function renderLegalConsentFormSection() {
    var submittingMeeting = this.props.submittingMeeting;


    return _react2.default.createElement(_LegalConsentForm2.default, {
      key: 'full-legalConsent',
      goToPreviousStep: this.getLegalBackFunction(),
      submittingMeeting: submittingMeeting
    });
  },
  renderStep: function renderStep() {
    var _props6 = this.props,
        shouldShowEmailForm = _props6.shouldShowEmailForm,
        bookingLifecycle = _props6.bookingLifecycle,
        formState = _props6.formState,
        autoSubmitPropertyFormInvalid = _props6.autoSubmitPropertyFormInvalid,
        legalConsentEnabled = _props6.legalConsentEnabled,
        legalConsentResponses = _props6.legalConsentResponses,
        submittingMeeting = _props6.submittingMeeting;


    if (shouldShowEmailForm) {
      return this.renderEmailForm();
    }
    if (!bookingLifecycle.event.dateString || !bookingLifecycle.event.dateTime) {
      return this.renderDateTimeStep();
    }

    if (!formState || autoSubmitPropertyFormInvalid) {
      return this.renderPropertyForm();
    }

    if (legalConsentEnabled && !legalConsentResponses) {
      return this.renderLegalConsentFormSection();
    }

    if (submittingMeeting) {
      return this.renderLastStep();
    }

    return null;
  },
  renderLastStep: function renderLastStep() {
    var legalConsentEnabled = this.props.legalConsentEnabled;


    if (legalConsentEnabled) {
      return this.renderLegalConsentFormSection();
    }

    return this.renderPropertyForm();
  },
  render: function render() {
    return _react2.default.createElement(
      'div',
      { className: this.getClassNames() },
      _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        {
          transitionName: 'step-animation',
          transitionEnterTimeout: 500,
          transitionLeave: false
        },
        this.renderStep()
      )
    );
  }
});

exports.default = (0, _reactRedux.connect)(null, FormActions)(FullSizeBookingPage);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/page/FullSizeBookingPage.js
// module id = 490
// module chunks = 0